var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueBigBridgePin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 51,
    viewBox: "0 0 40 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M20.647 48.457C32.216 38.65 38 29.164 38 20c0-9.941-8.059-18-18-18S2 10.059 2 20c0 9.164 5.784 18.65 17.353 28.457a1 1 0 0 0 1.294 0z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "144.4%",
    height: "133.4%",
    x: "-22.2%",
    y: "-25.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14BAD8",
    d: "M20.647 48.457C32.216 38.65 38 29.164 38 20c0-9.941-8.059-18-18-18S2 10.059 2 20c0 9.164 5.784 18.65 17.353 28.457a1 1 0 0 0 1.294 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13191F",
    d: "M25 27c1.41 0 2.72.202 3.9.538.719.206 1.244.416 1.547.568a1 1 0 0 1-.894 1.788c-.197-.098-.61-.263-1.203-.432A12.202 12.202 0 0 0 25 29c-1.12 0-2.198.24-4.725.962C17.552 30.739 16.379 31 15 31c-1.41 0-2.72-.202-3.9-.538-.719-.206-1.244-.416-1.547-.568a1 1 0 0 1 .894-1.788c.197.098.61.263 1.203.432 1.008.289 2.135.462 3.35.462 1.12 0 2.198-.24 4.725-.962C22.448 27.261 23.621 27 25 27zm0-4c1.41 0 2.72.202 3.9.538.719.206 1.244.416 1.547.568a1 1 0 0 1-.894 1.788c-.197-.098-.61-.263-1.203-.432A12.202 12.202 0 0 0 25 25c-1.12 0-2.198.24-4.725.962C17.552 26.739 16.379 27 15 27c-1.41 0-2.72-.202-3.9-.538-.719-.206-1.244-.416-1.547-.568a1 1 0 0 1 .894-1.788c.197.098.61.263 1.203.432 1.008.289 2.135.462 3.35.462 1.12 0 2.198-.24 4.725-.962C22.448 23.261 23.621 23 25 23zm4-14a2 2 0 0 1 2 2v10a1 1 0 0 1-1.447.894c-.197-.098-.61-.263-1.203-.432A12.196 12.196 0 0 0 25.034 21l-.012.001c-.047.004-.047.004-.124.006a1 1 0 0 1-.98-1.202A4 4 0 1 0 16 19c.001.846.273 1.652.774 2.34a1 1 0 0 1-.694 1.582A9.028 9.028 0 0 1 15 23c-1.41 0-2.72-.202-3.9-.538-.719-.206-1.244-.416-1.547-.568A1 1 0 0 1 9 21V11a2 2 0 0 1 2-2zm0 2H11v9.332a12.095 12.095 0 0 0 3.343.651A5.892 5.892 0 0 1 14 19a6 6 0 0 1 12 0v.034a14.048 14.048 0 0 1 3 .534V11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBigBridgePin);
export default __webpack_public_path__ + "static/media/blue-big-bridge-pin.961eafd52cb53602aaae71b311110dc0.svg";
export { ForwardRef as ReactComponent };